const fragment = `
  id
  price
  defaultPrice
  minLotPrice
  externalId
  communityId
  communityPhaseId
  defaultSelection
  isSpecHomeOnly
  isDefaultElevationImageForCommunity
  community {
    id
    name
  }
  communityPhase {
    id
    phase
  }
  priceableId
  priceableType
`;

export const listPriceRulesQuery = `
  query ListPriceRules(
    $filter: PriceRuleFilterInput
  ) {
    items: listPriceRules(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createPriceRuleQuery = `
  mutation CreatePriceRule(
    $input: CreatePriceRuleInput!
  ) {
    item: createPriceRule(input: $input) {
      ${fragment}
    }
  }
`;

export const updatePriceRuleQuery = `
  mutation UpdatePriceRule(
    $input: UpdatePriceRuleInput!
  ) {
    item: updatePriceRule(input: $input) {
      ${fragment}
    }
  }
`;

export const deletePriceRuleQuery = `
  mutation DeletePriceRule(
    $id: Int!
  ) {
    item: deletePriceRule(id: $id) {
      ${fragment}
    }
  }
`;
